export default __webpack_public_path__ + "static/media/intro.e3fa4a80.png";